import styled from "styled-components"
import { colors } from "../../styles/GlobalStyles"

export const Wrapper = styled.div`
	> a > img {
		max-width: 100%;
		border-radius: 4px;
		transition: 0.5s;
		&:hover {
			box-shadow: 1px 5px 10px ${colors.washedBlack};
		}
	}
`
